import navigation from '../components/navigation';
import stats from '../components/stats';
import content from '../components/content';
import slider from '../components/slider';
import newsletter from '../components/newsletter';
import hero from '../components/hero';
import ie11 from '../components/ie11';
import LazyLoad from 'lazyload';

export default {
  init() {
    navigation.init();
    stats.init();
    content.init();
    slider.init();
    newsletter.init();
    hero.init();
    ie11.init();
    new LazyLoad($('img'));
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
